module.exports = " <div id=main> <component :is=currentView></component> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/MainView.vue
// module id = 171
// module chunks = 2